import { GoogleLogo } from '@/assets/google-logo';
import { Button } from '@/components/ui/button';
import { Capacitor } from '@capacitor/core';
import { useAuthActions } from '@convex-dev/auth/react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { NATIVE_SOCIAL_LOGIN_REDIRECT_TO } from '../page';

export const GoogleLogin = () => {
  const { t } = useTranslation('login');
  const { signIn } = useAuthActions();

  const isNative = Capacitor.isNativePlatform();

  const redirectTo = isNative
    ? `${NATIVE_SOCIAL_LOGIN_REDIRECT_TO}google`
    : window.location.origin;

  const handleGoogleLogin = async () => {
    try {
      const options = { redirectTo };
      await signIn('google', options);
    } catch (error) {
      console.error('Google Sign In failed:', error);
      toast.error(t('signInFailed'));
    }
  };

  return (
    <Button onClick={handleGoogleLogin} variant="secondary" className="w-full">
      <div className="flex w-full flex-row items-center justify-center gap-3">
        <GoogleLogo className="-mt-0.25 size-5" />
        <span className="text-sm">{t('socialLogin.google')}</span>
      </div>
    </Button>
  );
};
